import styled from "styled-components";
import { LiveCasinoGridItemJackpotDefaultBox } from "./live-casino-grid-item-jackpot.default.box";

export const LiveCasinoGridItemJackpotCasino777Box = styled(LiveCasinoGridItemJackpotDefaultBox)`
    color: ${props => props.theme.colors.danger};
`;
